import React from 'react'
import NoData from '../../../../components/common/NoData';


function CourseOverview({ contentData }) {
  if (!contentData) {
    return <NoData message="No course overview available" description="Course details will appear here when they are added." />
  }

  return (
    <div className="tw-bg-[#fff] tw-border-[1px] tw-border-solid tw-border-[#e0e0e0] tw-rounded-[8px] tw-overflow-hidden tw-m-0 course-overview-card tw-p-0">
      <div className="tw-bg-[#f8f9fa] tw-p-[8px_15px] tw-font-medium tw-border-b-[1px] tw-border-solid tw-border-b-[#e0e0e0] content-duration tw-text-black">
        Duration: {contentData.duration}
      </div>
      <div className="tw-p-[15px] content-main">
        <h3 className="tw-text-[20px] tw-font-semibold tw-text-[#333] tw-m-[0_0_10px_0] tw-block [transition:all_0.2s_ease] tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis content-title">{contentData.title}</h3>
        <div className="tw-text-[#666] tw-m-0 tw-p-0 tw-overflow-hidden tw-text-ellipsis [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical] tw-text-[14px] content-description">
          <p>{contentData.description}</p>
        </div>
      </div>
    </div>
  )
}

export default CourseOverview
